import React from 'react';
import { useSelector } from 'react-redux';
import { setClassNames } from '@ddc/classnames-js';
import { useLabels } from 'wsm-common-data';

const SubHeading = () => {
	const { avgRating, totalRatings } = useSelector((state) => ({
		avgRating: state.reviewsInfo.avgRating,
		totalRatings: state.reviewsInfo.totalRatings
	}));
	const labels = useLabels();
	const headingText = labels
		.get('VW_REVIEWS_AVERAGE_SCORE')
		.replace('#{reviewsNumber}', totalRatings);
	const subHeadingClasses = ['sub-heading', 'text-center'];
	const starRatingClasses = ['sub-heading__rating', 'rating-stars'];
	const ratingStarSize = 1.75;
	const ratingStarsWidth = ratingStarSize * 5;
	const ratingStarHeight = ratingStarSize;
	const ratingStarFontSize = ratingStarSize;

	const style = {
		'--rating-star-value': `${avgRating}`,
		'--rating-stars-width': `${ratingStarsWidth}rem`,
		'--rating-star-height': `${ratingStarHeight}rem`,
		'--rating-star-font-size': `${ratingStarFontSize}rem`
	};
	return (
		<section className="mb-5">
			<h2 className={setClassNames(subHeadingClasses)}>
				{' '}
				{headingText}
				<span
					className={setClassNames(starRatingClasses)}
					style={style}
				/>
				{avgRating}
			</h2>
		</section>
	);
};

export default React.memo(SubHeading);
